<button (click)="onClickListner(leadForm)" mat-raised-button [ngStyle]="{'width': width, 'height': height}">{{label}}</button>

<ng-template #leadForm>
  <div [hidden]="isFormSubmit" class="header">
      <img loading="lazy" data-src="/assets/images/how-it-works/ketto-logo.svg" alt="" class="ketto-bird"/>
      <div class="title">Need Funds To Pay For Medical Bills/Treatment?</div>
      <div class="subtitle">Our personal fundraiser expert is waiting to get you started!</div>
  </div>
  <app-common-talktous-modal class="action-btns" [header]="false" label="Get a call"
														leadQueryType="want_to_raise_funds" frCause="medical" [askQuery]="false"
														[hideFields]="{typeOfQuery: true, cause: true}" (isFormSubmit)="isFormSubmit = $event">
	</app-common-talktous-modal>
</ng-template>